import * as swcHelpers from '@swc/helpers';
import React__default from 'react';
import { useQuery, useMutation } from '@grandvisionhq/graphql';
import { toPersonalDetails } from '../mappers/profile.js';
import UPDATE_PERSONAL_DETAILS from '../operations/mutations/update-personal-details.js';
import GET_PERSONAL_DETAILS from '../operations/queries/get-personal-details.js';

const usePersonalDetails = ({ onError , onCompleted  } = {})=>{
    var ref3, ref1;
    const setOptions = React__default.useCallback((reason)=>{
        return {
            onError: (error)=>{
                onError === null || onError === void 0 ? void 0 : onError({
                    reason,
                    error
                });
            },
            onCompleted: (data)=>{
                onCompleted === null || onCompleted === void 0 ? void 0 : onCompleted({
                    reason,
                    data
                });
            },
            // Currently the BE response does not resolve fast enough so we have to temporarily
            // increase the timeout that is configured globally in graphql/src/apollo/client.ts.
            // When the backend performance has been improved, we will remove this and revert
            // to the global config of 10s.
            context: {
                timeout: 20000
            }
        };
    }, [
        onCompleted,
        onError
    ]);
    /**
   * GQL query for retrieving personal details
   */ const queryOptions = React__default.useMemo(()=>setOptions('QUERY')
    , [
        setOptions
    ]);
    const query = useQuery(GET_PERSONAL_DETAILS, queryOptions);
    /**
   * GQL mutation for updating personal details
   */ const mutationOptions = React__default.useMemo(()=>setOptions('MUTATION')
    , [
        setOptions
    ]);
    const [mutationCallback, mutation] = useMutation(UPDATE_PERSONAL_DETAILS, swcHelpers.objectSpread({}, mutationOptions, {
        refetchQueries: [
            {
                query: GET_PERSONAL_DETAILS
            }
        ]
    }));
    return React__default.useMemo(()=>{
        var ref, ref2;
        return {
            personalDetailsData: toPersonalDetails((ref = query.data) === null || ref === void 0 ? void 0 : (ref2 = ref.me) === null || ref2 === void 0 ? void 0 : ref2.personalDetails),
            updatePersonalDetails: function() {
                var _ref = swcHelpers.asyncToGenerator(function*(personalDetails, userId) {
                    yield mutationCallback({
                        variables: {
                            customerId: userId,
                            input: personalDetails
                        }
                    });
                });
                return function(personalDetails, userId) {
                    return _ref.apply(this, arguments);
                };
            }(),
            isFetching: query.loading,
            fetchError: query.error,
            isUpdating: mutation.loading
        };
    }, [
        mutation.loading,
        mutationCallback,
        (ref3 = query.data) === null || ref3 === void 0 ? void 0 : (ref1 = ref3.me) === null || ref1 === void 0 ? void 0 : ref1.personalDetails,
        query.error,
        query.loading, 
    ]);
};

export { usePersonalDetails };
//# sourceMappingURL=use-personal-details.js.map
